
document.addEventListener("DOMContentLoaded", function () {
  const navBlocks = document.querySelectorAll(".faqs-categories");
  navBlocks.forEach(nav => {
      const container = nav.closest(".faqs-container");
      if (!container){ return; }

      const sections = container.querySelectorAll(".faq-category[id]");
      const navLinks = nav.querySelectorAll("a");

      // Map section ID → nav link
      const sectionMap = {};
      navLinks.forEach(link => {
          const targetId = link.getAttribute("href").replace("#", "");
          sectionMap[targetId] = link;
      });

      const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  const id = entry.target.id;
                  // Remove active from all links in THIS nav only
                  navLinks.forEach(link => link.classList.remove("active"));
                  // Add active to the matching one
                  if (sectionMap[id]) {
                      sectionMap[id].classList.add("active");
                  }
              }
          });
      }, {
          root: null,
          rootMargin: "-50% 0px -50% 0px",
          threshold: 0
      });

      sections.forEach(section => observer.observe(section));
  });
});

jQuery(function ($) {
  const $faqs       = $('.faqs');
  const $search     = $('.js-faqs-search');
  const $categories = $faqs.find('.faq-category');
  const $items      = $faqs.find('.accordion-item');

  // Normalise text safely (with fallback if .normalize isn't supported)
  function norm(str) {
    const s = (str || '').toString().toLowerCase().replace(/\s+/g, ' ').trim();
    try {
      return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (e) {
      return s;
    }
  }

  // Pre-index each item (question + answer + category name)
  $items.each(function () {
    const $item = $(this);
    const q   = $item.find('h3').text();
    const a   = $item.find('.accordion-panel').text();
    const cat = $item.closest('.faq-category').data('name') || '';
    $item.data('index', norm(`${q} ${a} ${cat}`));
  });

  function closeItem($item) {
    const $btn = $item.find('.accordion-trigger');
    if (!$btn.length) return;
    const panelId = $btn.attr('aria-controls');
    $btn.attr('aria-expanded', 'false');
    if (panelId) $('#' + panelId).attr('hidden', '').hide();
  }

  function filterFAQs(raw) {
    const q = norm(raw);
    let total = 0;

    // Mark matches (don't decide category visibility yet)
    $items.each(function () {
      const $item = $(this);
      const hay   = $item.data('index') || '';
      const match = !q || hay.indexOf(q) !== -1;

      $item.toggleClass('is-match', match)
           .toggleClass('is-hidden', !match);

      if (!match) closeItem($item);
      if (match) total++;
    });

    // Now toggle categories based on match state (NOT :visible)
    $categories.each(function () {
      const $cat = $(this);
      const catMatches = $cat.find('.accordion-item.is-match').length;
      $cat.toggleClass('is-hidden', catMatches === 0);
    });

    // Expose result count
    $faqs.data('results', total);
    window.faqResults = total;
    $faqs.trigger('faq:results', { count: total });

    return total;
  }

  // Small debounce
  let t;
  $search.on('input', function () {
    clearTimeout(t);
    const val = this.value;
    t = setTimeout(() => filterFAQs(val), 120);
  });

  // Initial: show all
  filterFAQs('');
});
